// list of ids and labels
// converted to { id, label } below
const list = [
    ['amazon', 'Amazon'],
    ['academia', 'Academia'],
    ['angel-list', 'AngelList'],
    ['bandcamp', 'Bandcamp'],
    ['behance', 'Behance'],
    ['bereal', 'BeReal'],
    ['buy-me-a-coffee', 'Buy Me A Coffee'],
    ['blogger', 'Blogger'],
    ['bluesky', 'Bluesky'],
    ['cara', 'Cara'],
    ['care', 'Care.com'],
    ['cashapp', 'Cash App'],
    ['clippings', 'Clippings.me'],
    ['codepen', 'CodePen'],
    ['deviantart', 'DeviantArt'],
    ['discord', 'Discord'],
    ['dlive', 'Dlive'],
    ['dribbble', 'Dribbble'],
    ['duolingo', 'Duolingo'],
    ['etsy', 'Etsy'],
    ['facebook', 'Facebook'],
    ['fitbit', 'Fitbit'],
    ['fiverr', 'Fiverr'],
    ['flickr', 'Flickr'],
    ['flipboard', 'Flipboard'],
    ['foursquare', 'Foursquare'],
    ['github', 'GitHub'],
    ['gitlab', 'GitLab'],
    ['gofundme', 'GoFundMe'],
    ['goodreads', 'Goodreads'],
    ['google-scholar', 'Google Scholar'],
    ['highbrow', 'Highbrow'],
    ['huggingface', 'Huggingface'],
    ['imdb', 'IMDb'],
    ['indiegogo', 'Indiegogo'],
    ['instagram', 'Instagram'],
    ['itch', 'itch.io'],
    ['kickstarter', 'Kickstarter'],
    ['lastfm', 'LastFM'],
    ['letterboxd', 'Letterboxd'],
    ['linkedin', 'LinkedIn'],
    ['linktree', 'Linktree'],
    ['medium', 'Medium'],
    ['mastodon', 'Mastodon'],
    ['mixcloud', 'Mixcloud'],
    ['odysee', 'Odysee'],
    ['orcid', 'ORCID'],
    ['patreon', 'Patreon'],
    ['picfair', 'Picfair'],
    ['pinterest', 'Pinterest'],
    ['pixelfed', 'Pixelfed'],
    ['pocket', 'Pocket'],
    ['post.news', 'Post'],
    ['product-hunt', 'Product Hunt'],
    ['px500', '500px'],
    ['quora', 'Quora'],
    ['reddit', 'Reddit'],
    ['researcherid', 'ResearcherID'],
    ['researchgate', 'ResearchGate'],
    ['scopus', 'Scopus'],
    ['scribd', 'Scribd'],
    ['sketchfab', 'Sketchfab'],
    ['skillshare', 'Skillshare'],
    ['slideshare', 'SlideShare'],
    ['snapchat', 'Snapchat'],
    ['soundcloud', 'SoundCloud'],
    ['spotify', 'Spotify'],
    ['substack', 'Substack'],
    ['stackexchange', 'Stack Exchange'],
    ['stackoverflow', 'Stack Overflow'],
    ['stage32', 'Stage 32'],
    ['strava', 'Strava'],
    ['telegram', 'Telegram'],
    ['threads', 'Threads'],
    ['tiktok', 'TikTok'],
    ['triller', 'Triller'],
    ['tumblr', 'Tumblr'],
    ['twitch', 'Twitch'],
    ['twitter', 'Twitter'],
    ['unsplash', 'Unsplash'],
    ['upwork', 'Upwork'],
    ['vimeo', 'Vimeo'],
    ['vine', 'Vine'],
    ['vk', 'VK'],
    ['vsco', 'VSCO'],
    ['weibo', 'Weibo'],
    ['web-of-science', 'Web of Science'],
    ['whatsapp', 'WhatsApp'],
    ['wikipedia', 'Wikipedia'],
    ['wordpress', 'WordPress'],
    ['xbox', 'Xbox'],
    ['xing', 'Xing'],
    ['yelp', 'Yelp'],
    ['youtube', 'YouTube'],
]

// convert the above list into a list of objects with { id, label }
module.exports = list.map((item) => {
    return {
        id: item[0],
        label: item[1],
    }
})
